import baseService from "@common/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  solicitacao(cpfcnpj) {
    return http.get("/DecaSolicitacaoExterno/Solicitacao", {
      params: {
        cpfcnpj: cpfcnpj
      }
    });
  },
};

export default apiDef;
